export const TEXTS_VARIABLE = {
  util: {
    title: '¿Te fue util la información?',
    btnSucces: 'Si, gracias',
    btnFail: 'No realmente',
    feedback: 'Gracias por tu respuesta, nos ayuda a seguir creciendo.',
  },
  category: {
    link: 'Ver todo',
  },
  searchBar: {
    resultsDesktop: 'Resultados de búsqueda de: ',
    notFoundDesktop: 'No encontramos resultados para ',
    notFoundMobile: 'No encontramos resultados para ',
  },
  breadcrumb: {
    HelpCenter: 'Centro de ayuda',
  },

  defaultTitle: `Centro de ayuda en Naranja X`,
  dinamicTitle: (text: string): string =>
    `Centro de ayuda de ${text} en Naranja X`,
  searchTitle: (text: string): string =>
    `Resultados para "${text}" en Centro de Ayuda de Naranja X`,
  titles: {
    contact: 'Canales de atención',
    phones: 'Teléfonos',
  },
};
